import { createContext } from "react";
const PlansContext = createContext();
export default PlansContext;

